import { RCanalisationDebitMinMaxSchema_Type } from '@batical/types/src'
import { fetchGeneric, fetchGenericSorted } from './GenericQ'
const RCanalisationDebitMinMax: Array<RCanalisationDebitMinMaxSchema_Type> = require('../json/CanalsationDebitMinMax.json')

export function fetchCanalisationDebitMinMaxSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(RCanalisationDebitMinMax)
}

export function fetchCanalisationDebitMinMax(uuid: string): RCanalisationDebitMinMaxSchema_Type {
  return fetchGeneric(RCanalisationDebitMinMax, uuid)
}
